import MoreVertIcon from "@mui/icons-material/MoreVert";
import VerticalAlignBottomIcon from "@mui/icons-material/VerticalAlignBottom";
import VerticalAlignTopIcon from "@mui/icons-material/VerticalAlignTop";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { DASH, STATS } from "../../lib/constants.js";

function extractStats({ stats }) {
  const sortedStats = stats.sort((a, b) => b.value - a.value);
  const highestStats = sortedStats.slice(0, 2);
  const lowestStats = sortedStats.slice(-2);

  return [...highestStats, ...lowestStats];
}

function StatRow({ icon, name, value }) {
  return (
    <ListItem>
      <ListItemIcon sx={{ minWidth: STATS.ICON_SIZE }}>{icon}</ListItemIcon>
      <Box display="flex" alignItems="baseline" flexGrow={1}>
        <ListItemText
          primary={
            <Typography
              variant="body2"
              sx={{ ":first-letter": { textTransform: "capitalize" } }}
            >
              {name}
            </Typography>
          }
        />
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{
            borderRadius: "100%",
            border: "1px solid",
            borderColor: "primary.main",
            width: STATS.VALUE_CIRCLE,
            height: STATS.VALUE_CIRCLE,
          }}
        >
          <Typography variant="caption">{value}</Typography>
        </Box>
      </Box>
    </ListItem>
  );
}

export default function DataBoxStats({ route, state, stats, title }) {
  const statsToShow = useMemo(() => extractStats({ stats }), [stats]);
  const hasStats = state?.id && Boolean(statsToShow.length);

  return (
    <Box sx={hasStats ? {} : { display: "flex", alignItems: "center", gap: 2 }}>
      <Typography
        color="secondary"
        component={hasStats ? Link : null}
        to={route}
        state={state}
        sx={{ textTransform: "uppercase", letterSpacing: 1 }}
        variant="body2"
      >
        {title}
      </Typography>
      {!hasStats ? (
        <Typography variant="body2">{DASH}</Typography>
      ) : (
        <List dense disablePadding>
          {statsToShow.map((stat, index) => {
            const { category, value } = stat;
            const isHighestStat = index === 0;
            const isLowestStat = index === statsToShow.length - 1;
            const icon = isHighestStat ? (
              <VerticalAlignTopIcon color="primary" fontSize="small" />
            ) : isLowestStat ? (
              <VerticalAlignBottomIcon color="primary" fontSize="small" />
            ) : (
              <MoreVertIcon color="primary" fontSize="small" />
            );
            return (
              <StatRow icon={icon} key={index} name={category} value={value} />
            );
          })}
        </List>
      )}
    </Box>
  );
}
